(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["popbrush-linked-designs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('popbrush-linked-designs')) {
    customElements.define('popbrush-linked-designs', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected || this.abort) return;
        this.list = this.querySelector('[data-linked-list]');
        this.controls = this.querySelector('[data-linked-controls]');
        this.previous = this.querySelector('[data-linked-prev]');
        this.next = this.querySelector('[data-linked-next]');
        if (!this.list || !this.controls || !this.previous || !this.next) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const update = () => {
          const maximum = this.list.scrollWidth - this.list.clientWidth;
          this.controls.hidden = maximum < 2;
          this.previous.disabled = this.list.scrollLeft <= 4;
          this.next.disabled = this.list.scrollLeft >= maximum - 4;
        };
        const move = direction => this.list.scrollBy({
          left: direction * Math.max(96, this.list.clientWidth - 96),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
        this.previous.addEventListener('click', () => move(-1), { signal });
        this.next.addEventListener('click', () => move(1), { signal });
        this.list.addEventListener('scroll', update, { signal, passive: true });
        this.resize = new ResizeObserver(update);
        this.resize.observe(this.list);
        const current = this.list.querySelector('[aria-current="page"]');
        if (current) {
          this.list.scrollLeft = current.getBoundingClientRect().left - this.list.getBoundingClientRect().left - (this.list.clientWidth - current.offsetWidth) / 2;
        }
        update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.resize?.disconnect();
        this.abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
